export default __webpack_public_path__ + "static/media/chalk_background.0163f1a1.png";